import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=e86b07e6&scoped=true"
import script from "./BoardList.vue?vue&type=script&lang=js"
export * from "./BoardList.vue?vue&type=script&lang=js"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=e86b07e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86b07e6",
  null
  
)

export default component.exports